const YOUTUBE_PATTERN =
  /(?:^|[^a-z0-9])(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com|youtu\.be)(?:\/[^\s]*)?/i;

export function containsYouTubeUrl(text: string): boolean {
  return YOUTUBE_PATTERN.test(text);
}

export const TERMS_REQUIRED_MESSAGE = 'You must accept the Terms of Use before posting.';
